"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5643],{

/***/ 85643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Bk": function() { return /* binding */ QualificationContext; },
  "S": function() { return /* binding */ QualificationProvider; },
  "_8": function() { return /* reexport */ useQualification/* useQualification */._; },
  "qj": function() { return /* binding */ withQualificationProvider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./src/lib/yup.ts
var yup = __webpack_require__(33448);
// EXTERNAL MODULE: ./src/qualification/context/model.ts
var model = __webpack_require__(91538);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/deepmerge/dist/cjs.js
var cjs = __webpack_require__(9996);
var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);
// EXTERNAL MODULE: ./src/lib/ablyft/index.ts
var ablyft = __webpack_require__(49423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./src/qualification/schema/questions/index.ts
var questions = __webpack_require__(89121);
// EXTERNAL MODULE: ./src/qualification/schema/steps/index.ts
var schema_steps = __webpack_require__(82546);
;// CONCATENATED MODULE: ./src/qualification/context/reducer/utils.ts


function getAnswer(state, questionId) {
    return "qualification" in state ? state.qualification.answers[questionId] : undefined;
}
function getErrors(state, question) {
    return state.qualification.errors[question.id];
}
function isStepValid(state, stepId) {
    var step = schema_steps/* SCHEMA_STEPS */.C$[stepId];
    return step.questions.map(function(child) {
        return isQuestionValid(state, child.id);
    }).every(function(item) {
        return !!item;
    });
}
function isQuestionValid(state, questionId) {
    var question = questions/* SCHEMA_QUESTIONS */.x[questionId];
    var answer = state.qualification.answers[question.id];
    var errors = state.qualification.errors[question.id];
    return !(errors === null || errors === void 0 ? void 0 : errors.length) && answer !== undefined;
}
function getStepIndexAndPercentage(step, steps) {
    var enabledSteps = steps.filter(function(q) {
        return !q.disabled;
    });
    var stepIndex = enabledSteps.findIndex(function(_step) {
        return _step.id === step.id;
    });
    var progressPercentage = Math.round(stepIndex / (enabledSteps.length - 1) * 100);
    return {
        stepIndex: stepIndex,
        progressPercentage: progressPercentage
    };
}
function getFirstUnansweredStep(state) {
    return state.qualification.steps.find(function(q) {
        return !isStepValid(state, q.id);
    });
}
function getFirstShownStep(state) {
    var ref;
    var nonSkippableQuestions = (ref = state.initialOptions) === null || ref === void 0 ? void 0 : ref.nonSkippableQuestions;
    var firstStepToShow = state.qualification.steps.find(function(step, index) {
        var isLastStep = index === state.qualification.steps.length - 1;
        if (step.disabled) {
            return false;
        }
        var isCorrectlyAnswered = isStepValid(state, step.id);
        if (isCorrectlyAnswered) {
            return false;
        }
        var canBeSkipped = nonSkippableQuestions ? !nonSkippableQuestions.includes(step.id) : true;
        if (!canBeSkipped) {
            return true;
        }
        if (isLastStep) {
            return true;
        }
        return true;
    });
    return firstStepToShow || state.qualification.steps.filter(function(q) {
        return !q.disabled;
    })[0];
}
function disableStep(state, stepId) {
    var step = state.qualification.steps.find(function(step) {
        return step.id === stepId;
    });
    if (step) {
        step.disabled = true;
    }
}

// EXTERNAL MODULE: ./src/qualification/schema/questions/budgetQuestion.ts
var budgetQuestion = __webpack_require__(92789);
// EXTERNAL MODULE: ./src/qualification/schema/questions/cateringCategoriesQuestion.ts
var cateringCategoriesQuestion = __webpack_require__(61535);
// EXTERNAL MODULE: ./src/qualification/schema/questions/dietaryRestrictionsQuestion.ts
var dietaryRestrictionsQuestion = __webpack_require__(69307);
;// CONCATENATED MODULE: ./src/qualification/context/reducer/answerQuestion.ts











var DEFAULT_OPTIONS = {
    storeIfInvalid: true
};
function answerQuestion(state, answer) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var question = questions/* SCHEMA_QUESTIONS */.x[answer.id];
    if (!question || !state.qualification.answers) {
        return state;
    }
    var ref = (0,_object_spread/* default */.Z)({}, DEFAULT_OPTIONS, options), storeIfInvalid = ref.storeIfInvalid, isSideEffect = ref.isSideEffect;
    var payload = answer.value;
    var answerOptions = answer.options || {
        isManagedAccount: false
    };
    var isManagedAccount = answerOptions.isManagedAccount;
    if (question.getValidator({
        answers: state.qualification.answers,
        isManagedAccount: isManagedAccount
    }).type === "array" && !Array.isArray(answer.value)) {
        var prevAnswer = getAnswer(state, question.id);
        if (prevAnswer === undefined) {
            payload = [
                answer.value
            ];
        } else if (Array.isArray(prevAnswer) && prevAnswer.includes(answer.value)) {
            payload = prevAnswer.filter(function(_answer) {
                return _answer !== payload;
            });
        } else if (Array.isArray(prevAnswer)) {
            payload = (0,_to_consumable_array/* default */.Z)(prevAnswer).concat([
                answer.value
            ]);
        }
    }
    var errors = validateAnswer(question, payload, state, {
        isManagedAccount: isManagedAccount
    });
    var isInvalid = Boolean(errors && errors.length > 0);
    if (isInvalid && !storeIfInvalid) {
        return state;
    }
    var newState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification), {
            answers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification.answers), (0,_define_property/* default */.Z)({}, answer.id, payload)),
            errors: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification.errors), (0,_define_property/* default */.Z)({}, answer.id, errors))
        })
    });
    // Handle Side effects
    if (!isSideEffect) {
        if (!newState._firstAnsweredBudgetField) {
            if (answer.id === questions/* questions.peopleCount.id */.X.peopleCount.id) {
                newState._firstAnsweredBudgetField = "peopleCount";
            }
            if (answer.id === questions/* questions.totalBudget.id */.X.totalBudget.id) {
                newState._firstAnsweredBudgetField = "totalBudget";
            }
        }
        if (answer.id === questions/* questions.peopleCount.id */.X.peopleCount.id) {
            newState._isPeopleCountTouched = true;
        }
        newState = handlePeopleCountChange(newState, answer);
        newState = handleDietaryRestrictionsChange(newState, answer);
        newState = handlePricePerPersonChange(newState, answer);
        newState = handleTotalBudgetChange(newState, answer, {
            isManagedAccount: isManagedAccount
        });
        if (answer.id === cateringCategoriesQuestion/* cateringCategoriesQuestion.id */.BN.id) {
            newState = handleCateringCategoryChange(newState);
        }
    }
    return newState;
}
function validateAnswer(question, answer, state) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (!question) {
        return null;
    }
    try {
        if ("getValidator" in question) {
            var ref;
            (ref = question.getValidator({
                answers: state.qualification.answers,
                selectedCaterer: state.qualification.selectedCaterer,
                isManagedAccount: options.isManagedAccount
            })) === null || ref === void 0 ? void 0 : ref.validateSync(answer, {
                context: state.qualification.answers
            });
        }
    } catch (e) {
        if ((0,_instanceof/* default */.Z)(e, es.ValidationError)) {
            return e.errors;
        }
    }
    return null;
}
function handleCateringCategoryChange(state) {
    var pricePerQuestionAnswer = state.qualification.answers[budgetQuestion/* pricePerPersonQuestion.id */.fk.id];
    if (pricePerQuestionAnswer !== undefined) {
        var newState = answerQuestion(state, {
            id: budgetQuestion/* pricePerPersonQuestion.id */.fk.id,
            value: state.qualification.answers[budgetQuestion/* pricePerPersonQuestion.id */.fk.id]
        }, {
            isSideEffect: true
        });
        return newState;
    }
    return state;
}
function handleDietaryRestrictionsChange(state, answer) {
    var ref;
    var currentStep = state.qualification.step;
    if ((currentStep === null || currentStep === void 0 ? void 0 : currentStep.id) !== "dietary_restrictions") {
        return state;
    }
    if (typeof answer.value !== "number") {
        return state;
    }
    var newState = (0,_object_spread/* default */.Z)({}, state);
    if ([
        "number_of_carnivore",
        "number_of_vegetarians",
        "number_of_vegans", 
    ].includes(answer.id) && ((ref = state.qualification.step) === null || ref === void 0 ? void 0 : ref.id) === "dietary_restrictions") {
        var ref1 = [
            questions/* SCHEMA_QUESTIONS */.x[questions/* questions.numberOfCarnivore.id */.X.numberOfCarnivore.id],
            questions/* SCHEMA_QUESTIONS */.x[questions/* questions.numberOfVegans.id */.X.numberOfVegans.id],
            questions/* SCHEMA_QUESTIONS */.x[questions/* questions.numberOfVegetarians.id */.X.numberOfVegetarians.id], 
        ], carnivoreQuestion = ref1[0], vegansQuestion = ref1[1], vegetariansQuestion = ref1[2];
        if (carnivoreQuestion && vegetariansQuestion && vegansQuestion) {
            var ref2 = [
                answer.id === "number_of_carnivore" ? answer.value : getAnswer(state, carnivoreQuestion.id) || 0,
                answer.id === "number_of_vegetarians" ? answer.value : getAnswer(state, vegetariansQuestion.id) || 0,
                answer.id === "number_of_vegans" ? answer.value : getAnswer(state, vegansQuestion.id) || 0, 
            ], carnivoreCount = ref2[0], vegetarianCount = ref2[1], veganCount = ref2[2];
            var peopleCount = carnivoreCount + vegetarianCount + veganCount;
            if (peopleCount !== state.qualification.answers.min_order_number) {
                newState = answerQuestion(state, {
                    id: "min_order_number",
                    value: peopleCount
                }, {
                    isSideEffect: true
                });
            }
        }
    }
    return newState;
}
function handlePeopleCountChange(state, answer) {
    var currentQuestion = state.qualification.step;
    var peopleCount = answer.value;
    var newState = (0,_object_spread/* default */.Z)({}, state);
    if (answer.id !== questions/* questions.peopleCount.id */.X.peopleCount.id || typeof peopleCount !== "number") {
        return state;
    }
    var totalBudget = state.qualification.answers[budgetQuestion/* totalBudgetQuestion.id */.JL.id];
    var pricePerPerson = state.qualification.answers[budgetQuestion/* pricePerPersonQuestion.id */.fk.id];
    if (state._firstAnsweredBudgetField === "totalBudget" && totalBudget) {
        // update the price per person
        var calculatedPricePerPerson = Math.round(totalBudget / peopleCount * 100) / 100;
        if (calculatedPricePerPerson !== pricePerPerson) {
            newState = answerQuestion(newState, {
                id: budgetQuestion/* pricePerPersonQuestion.id */.fk.id,
                value: calculatedPricePerPerson
            }, {
                isSideEffect: true
            });
        }
    }
    // Update total budget
    if (state._firstAnsweredBudgetField === "peopleCount") {
        var pricePerPerson1 = state.qualification.answers.price_per_person;
        if (pricePerPerson1) {
            var updatedOrderAmount = pricePerPerson1 * peopleCount;
            if (totalBudget !== updatedOrderAmount) {
                newState = answerQuestion(newState, {
                    id: "caterer_minimum_order_value",
                    value: updatedOrderAmount
                }, {
                    isSideEffect: true
                });
            }
        }
    }
    // Update dietary distribution
    if ((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id) !== "dietary_restrictions") {
        var carnivoreCount = Math.round(dietaryRestrictionsQuestion/* DEFAULT_DIETARY_PERCENTAGE.carnivore */.JF.carnivore * peopleCount);
        var vegetarianCount = Math.round(dietaryRestrictionsQuestion/* DEFAULT_DIETARY_PERCENTAGE.vegetarian */.JF.vegetarian * peopleCount);
        var veganCount = peopleCount - carnivoreCount - vegetarianCount;
        newState = answerQuestion(newState, {
            id: "number_of_carnivore",
            value: carnivoreCount
        }, {
            isSideEffect: true
        });
        newState = answerQuestion(newState, {
            id: "number_of_vegans",
            value: veganCount
        }, {
            isSideEffect: true
        });
        newState = answerQuestion(newState, {
            id: "number_of_vegetarians",
            value: vegetarianCount
        }, {
            isSideEffect: true
        });
    }
    return newState;
}
function handleTotalBudgetChange(state, answer, options) {
    if (answer.id !== budgetQuestion/* totalBudgetQuestion.id */.JL.id || typeof answer.value !== "number") {
        return state;
    }
    var pricePerPerson = state.qualification.answers[budgetQuestion/* pricePerPersonQuestion.id */.fk.id];
    var peopleCount = state.qualification.answers[questions/* questions.peopleCount.id */.X.peopleCount.id];
    var newState = state;
    // update price per person
    if (state._firstAnsweredBudgetField === "peopleCount" && peopleCount) {
        var calculatedPricePerPerson = Math.round(answer.value / peopleCount * 100) / 100;
        if (calculatedPricePerPerson !== pricePerPerson) {
            newState = answerQuestion(newState, {
                id: budgetQuestion/* pricePerPersonQuestion.id */.fk.id,
                value: calculatedPricePerPerson,
                options: options || {}
            }, {
                isSideEffect: true
            });
        }
    }
    var totalBudget = answer.value;
    // update peopleCount
    if (state._firstAnsweredBudgetField === "totalBudget") {
        // Update the people count
        if (pricePerPerson && totalBudget) {
            if (!state._isPeopleCountTouched) {
                var newPeopleCount = Math.floor(totalBudget / pricePerPerson);
                newState = answerQuestion(newState, {
                    id: questions/* questions.peopleCount.id */.X.peopleCount.id,
                    value: newPeopleCount
                }, {
                    isSideEffect: true
                });
                // Update the price per person
                if (newPeopleCount) {
                    newState = answerQuestion(newState, {
                        id: budgetQuestion/* pricePerPersonQuestion.id */.fk.id,
                        value: Math.round(totalBudget / newPeopleCount * 100) / 100
                    }, {
                        isSideEffect: true
                    });
                }
            }
            if (state._isPeopleCountTouched && peopleCount) {
                newState = answerQuestion(newState, {
                    id: budgetQuestion/* pricePerPersonQuestion.id */.fk.id,
                    value: Math.round(totalBudget / peopleCount * 100) / 100
                }, {
                    isSideEffect: true
                });
            }
        }
    }
    return newState;
}
function handlePricePerPersonChange(state, answer) {
    if (answer.id !== budgetQuestion/* pricePerPersonQuestion.id */.fk.id || typeof answer.value !== "number") {
        return state;
    }
    var peopleCount = state.qualification.answers.min_order_number;
    // CHANGE: price per person
    if (answer.id === budgetQuestion/* pricePerPersonQuestion.id */.fk.id) {
        if (peopleCount) {
            // update totalBudget
            var sumPrice = answer.value * peopleCount;
            if (sumPrice !== state.qualification.answers.min_order_number) {
                return answerQuestion(state, {
                    id: budgetQuestion/* totalBudgetQuestion.id */.JL.id,
                    value: Math.floor(sumPrice)
                });
            }
        }
    }
    return state;
}

// EXTERNAL MODULE: ./src/qualification/schema/questions/cityQuestion.tsx
var cityQuestion = __webpack_require__(26407);
;// CONCATENATED MODULE: ./src/shared/helpers/object.ts
/**
 * An `Object.entries` alternative which has proper typing of the returned tuples
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function typedEntries(object) {
    return Object.entries(object);
}

;// CONCATENATED MODULE: ./src/qualification/context/reducer/answerInitialQuestions.ts







function answerInitialQuestions(state, answers) {
    var stateWithAnswers = (0,_object_spread/* default */.Z)({}, state);
    if (answers) {
        var answerTuples = typedEntries(answers);
        answerTuples.forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), answerId = _param[0], answerValue = _param[1];
            stateWithAnswers = answerQuestion(stateWithAnswers, {
                id: answerId,
                value: answerValue
            }, {
                storeIfInvalid: false
            });
            if (state.qualification.selectedMenu) {
                stateWithAnswers = answerQuestion(stateWithAnswers, {
                    id: "catering_categories",
                    value: state.qualification.selectedMenu.cateringCategories
                }, {
                    storeIfInvalid: false
                });
            }
        });
    }
    // Handle If only a single item is supported
    var funnelHasCityQuestion = state.qualification.steps.find(function(q) {
        return q.id === cityQuestion/* cityStep.id */.pv.id;
    });
    if (funnelHasCityQuestion) {
        var items = cityQuestion/* cityQuestion.getItems */.Vv.getItems({
            answers: answers || {},
            selectedCaterer: stateWithAnswers.qualification.selectedCaterer
        });
        if ((items === null || items === void 0 ? void 0 : items.length) === 1) {
            stateWithAnswers = answerQuestion(stateWithAnswers, {
                id: "city",
                value: items[0].value
            }, {
                storeIfInvalid: false
            });
            disableStep(stateWithAnswers, "city");
        }
    }
    var funnelHasCateringCategoryQuestion = state.qualification.steps.find(function(q) {
        return q.id === cateringCategoriesQuestion/* cateringCategoriesQuestion.id */.BN.id;
    });
    if (funnelHasCateringCategoryQuestion) {
        var items1 = cateringCategoriesQuestion/* cateringCategoriesQuestion.getItems */.BN.getItems({
            answers: answers || {},
            selectedCaterer: state.qualification.selectedCaterer
        });
        if (items1.length === 1) {
            stateWithAnswers = answerQuestion(stateWithAnswers, {
                id: "catering_categories",
                value: items1[0].value
            }, {
                storeIfInvalid: false
            });
            disableStep(stateWithAnswers, "catering_categories");
        }
    }
    return stateWithAnswers;
}

;// CONCATENATED MODULE: ./src/qualification/context/reducer/initialize.ts









function initialize(state) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, answers = ref.answers, disabledSteps = ref.disabledSteps, leadSource = ref.leadSource, nonSkippableQuestions = ref.nonSkippableQuestions, selectedCaterer = ref.selectedCaterer, selectedMenu = ref.selectedMenu, stepOrder = ref.stepOrder, variations = ref.variations;
    var currentPageHref =  false ? 0 : "".concat(window.location.origin).concat(window.location.pathname);
    leadSource = leadSource || currentPageHref;
    var isUserLoggedIn =  true && window.localStorage.getItem("token");
    // Initialize the questions
    var steps = getInitialSteps({
        isUserLoggedIn: Boolean(isUserLoggedIn),
        variations: variations,
        stepOrder: stepOrder
    });
    // Define an initial state
    var initialState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        initialOptions: {
            nonSkippableQuestions: nonSkippableQuestions
        },
        status: model/* QUALIFICATION_STATUS.answering */.w.answering,
        qualification: {
            leadSource: leadSource,
            answers: {},
            errors: {},
            steps: steps.map(function(q) {
                return {
                    id: q.id
                };
            }),
            step: {
                id: schema_steps/* SCHEMA_STEPS.catering_categories.id */.C$.catering_categories.id
            },
            stepIndex: 0,
            progressPercentage: 0,
            selectedMenu: selectedMenu,
            selectedCaterer: selectedCaterer
        }
    });
    // Add initial answers
    var answeredState = answerInitialQuestions(initialState, answers);
    // Handle the selected menu
    if (selectedMenu) {
        answeredState = answerQuestion(answeredState, {
            id: "catering_categories",
            value: selectedMenu.cateringCategories
        });
        disableStep(answeredState, "catering_categories");
    }
    // Order the questions
    var orderedSteps = orderStepsBasedOnAnswers({
        steps: answeredState.qualification.steps,
        answers: answeredState.qualification.answers,
        ignoredAnswers: nonSkippableQuestions
    });
    var stateWithAnsweredAndOrderedQuestions = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, answeredState), {
        qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, answeredState.qualification), {
            steps: orderedSteps
        })
    });
    // Disable answers
    if (disabledSteps === null || disabledSteps === void 0 ? void 0 : disabledSteps.length) {
        disabledSteps.forEach(function(stepId) {
            var hasAnswer = isStepValid(stateWithAnsweredAndOrderedQuestions, stepId);
            if (hasAnswer) {
                disableStep(stateWithAnsweredAndOrderedQuestions, stepId);
            }
        });
    }
    // Determine the first shown question
    var firstShownStep = getFirstShownStep(stateWithAnsweredAndOrderedQuestions);
    var ref1 = getStepIndexAndPercentage(firstShownStep, orderedSteps), stepIndex = ref1.stepIndex, progressPercentage = ref1.progressPercentage;
    var initializedState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stateWithAnsweredAndOrderedQuestions), {
        status: model/* QUALIFICATION_STATUS.answering */.w.answering,
        qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stateWithAnsweredAndOrderedQuestions.qualification), {
            steps: orderedSteps,
            step: {
                id: firstShownStep.id
            },
            progressPercentage: progressPercentage,
            stepIndex: stepIndex,
            selectedCaterer: selectedCaterer
        })
    });
    return initializedState;
}
function getInitialSteps(param) {
    var isUserLoggedIn = param.isUserLoggedIn, stepOrder = param.stepOrder, variations = param.variations;
    var stepOrderToUse = (stepOrder === null || stepOrder === void 0 ? void 0 : stepOrder.map(function(stepId) {
        return schema_steps/* SCHEMA_STEPS */.C$[stepId];
    })) || [
        schema_steps/* steps.city */.S6.city,
        schema_steps/* steps.cateringCategories */.S6.cateringCategories,
        schema_steps/* steps.eventDateAndLeadType */.S6.eventDateAndLeadType,
        schema_steps/* steps.budgetAndPeopleCount */.S6.budgetAndPeopleCount,
        schema_steps/* steps.dietaryRestriction */.S6.dietaryRestriction, 
    ];
    var filteredSteps = handleConditionalQuestions(stepOrderToUse, {
        isUserLoggedIn: isUserLoggedIn
    });
    if (variations) {
        if (variations.includes(ablyft/* EXPERIMENT.customerTierABC.variations.variationB */.Op.customerTierABC.variations.variationB) || variations.includes(ablyft/* EXPERIMENT.customerTierABC.variations.variationC */.Op.customerTierABC.variations.variationC)) {
            filteredSteps.push(schema_steps/* steps.customerTier */.S6.customerTier);
        }
    }
    return filteredSteps;
}
function handleConditionalQuestions(steps, param) {
    var isUserLoggedIn = param.isUserLoggedIn;
    return steps.map(function(step) {
        var questions = step.questions;
        var filteredQuestions = questions.filter(function(question) {
            return !(question === null || question === void 0 ? void 0 : question.condition) || question.condition(Boolean(isUserLoggedIn));
        });
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, step), {
            questions: filteredQuestions
        });
    }).filter(function(step) {
        return step.questions.length > 0;
    });
}
function orderStepsBasedOnAnswers(param) {
    var steps = param.steps, answers = param.answers, ignoredAnswers = param.ignoredAnswers;
    // Get the keys from the object
    var keys = Object.keys(answers);
    var answeredSteps = [];
    var unansweredSteps = [];
    steps.forEach(function(step) {
        var isAnswered = keys.includes(step.id);
        var isIgnored = ignoredAnswers ? ignoredAnswers.includes(step.id) : false;
        if (isIgnored) {
            unansweredSteps.push(step);
            return;
        }
        if (isAnswered) {
            answeredSteps.push(step);
            return;
        }
        unansweredSteps.push(step);
    });
    return (0,_to_consumable_array/* default */.Z)(answeredSteps).concat((0,_to_consumable_array/* default */.Z)(unansweredSteps));
}

;// CONCATENATED MODULE: ./src/qualification/context/reducer/setQuestion.ts




function setQuestion(state, stepId) {
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return state;
    }
    var step = state.qualification.steps.find(function(_step) {
        return _step.id === stepId;
    });
    if (step) {
        var stepIndex = state.qualification.steps.indexOf(step);
        var prevSteps = state.qualification.steps.slice(0, stepIndex);
        var arePrevStepsAnsweredCorrectly = prevSteps.every(function(_step) {
            return isStepValid(state, _step.id);
        });
        var newStep = arePrevStepsAnsweredCorrectly ? step : getFirstUnansweredStep(state);
        if (!newStep || newStep.disabled) {
            return state;
        }
        var ref = getStepIndexAndPercentage(newStep, state.qualification.steps), newStepIndex = ref.stepIndex, progressPercentage = ref.progressPercentage;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification), {
                stepIndex: newStepIndex,
                progressPercentage: progressPercentage,
                step: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newStep), {
                    isValid: isStepValid(state, newStep.id)
                })
            })
        });
    }
    return state;
}

;// CONCATENATED MODULE: ./src/qualification/context/reducer/toNextStep.ts




function toNextStep(state, onFunnelFinished) {
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return state;
    }
    var step = state.qualification.step;
    if (!step) {
        return state;
    }
    var stepIndex = state.qualification.steps.findIndex(function(_step) {
        return _step.id === step.id;
    });
    var nextStep = state.qualification.steps[stepIndex + 1];
    if (!nextStep || (nextStep === null || nextStep === void 0 ? void 0 : nextStep.disabled)) {
        var funnelAnsweredState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            status: "answered",
            qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification), {
                answers: state.qualification.answers,
                steps: state.qualification.steps,
                selectedCaterer: state.qualification.selectedCaterer
            })
        });
        if (onFunnelFinished) {
            onFunnelFinished(funnelAnsweredState);
        }
        return funnelAnsweredState;
    }
    var ref = getStepIndexAndPercentage(nextStep, state.qualification.steps), newStepIndex = ref.stepIndex, progressPercentage = ref.progressPercentage;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification), {
            selectedCaterer: state.qualification.selectedCaterer,
            step: nextStep,
            stepIndex: newStepIndex,
            progressPercentage: progressPercentage
        })
    });
}
function canGoToNextStep(state) {
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return false;
    }
    var step = state.qualification.step;
    if (!step) {
        return false;
    }
    var isCurrentStepAnsweredCorrectly = isStepValid(state, state.qualification.step.id);
    if (!isCurrentStepAnsweredCorrectly) {
        return false;
    }
    var stepIndex = state.qualification.steps.findIndex(function(_step) {
        return _step.id === step.id;
    });
    var prevSteps = state.qualification.steps.slice(0, stepIndex);
    if (prevSteps.length) {
        var arePrevStepsAnsweredCorrectly = prevSteps.every(function(q) {
            var isValid = isStepValid(state, q.id);
            return isValid;
        });
        if (!arePrevStepsAnsweredCorrectly) {
            return false;
        }
    }
    return true;
}

;// CONCATENATED MODULE: ./src/qualification/context/reducer/toPrevStep.ts




function toPrevStep(state) {
    if (state.status === model/* QUALIFICATION_STATUS.qualifiedForRequest */.w.qualifiedForRequest) {
        var lastQuestion = state.qualification.steps[state.qualification.steps.length - 1];
        var ref = getStepIndexAndPercentage(lastQuestion, state.qualification.steps), stepIndex = ref.stepIndex, progressPercentage = ref.progressPercentage;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification), {
                step: lastQuestion,
                stepIndex: stepIndex,
                progressPercentage: progressPercentage,
                errors: {}
            }),
            status: model/* QUALIFICATION_STATUS.answering */.w.answering
        });
    }
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return state;
    }
    var step = state.qualification.step;
    if (!step) {
        return state;
    }
    var stepIndex1 = state.qualification.steps.findIndex(function(_step) {
        return _step.id === step.id;
    });
    var prevStep = state.qualification.steps[stepIndex1 - 1];
    if (!prevStep || (prevStep === null || prevStep === void 0 ? void 0 : prevStep.disabled)) {
        return state;
    }
    var ref1 = getStepIndexAndPercentage(prevStep, state.qualification.steps), newStepIndex = ref1.stepIndex, progressPercentage1 = ref1.progressPercentage;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification), {
            step: prevStep,
            stepIndex: newStepIndex,
            progressPercentage: progressPercentage1
        })
    });
}

;// CONCATENATED MODULE: ./src/qualification/context/reducer/index.ts














var DEBUG = false;
var qualificationReducer = function(state, action) {
    if (DEBUG) {
        var type = action.type, rest = (0,_object_without_properties/* default */.Z)(action, [
            "type"
        ]);
        console.groupCollapsed("QUALIFICATION: " + type);
        if (rest) {
            console.log(JSON.stringify(rest, null, 2));
        }
        console.groupEnd();
    }
    switch(action.type){
        case "initialize":
            {
                return initialize(state, action.payload);
            }
        case "reset":
            {
                return model/* DEFAULT_QUALIFICATION_STATE */.$;
            }
        case "answerQuestion":
            {
                if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
                    return state;
                }
                return answerQuestion(state, action.payload);
            }
        case "nextStep":
            {
                return toNextStep(state);
            }
        case "prevStep":
            {
                return toPrevStep(state);
            }
        case "setQuestion":
            {
                if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
                    return state;
                }
                return setQuestion(state, action.payload);
            }
        case "setReorderOfferId":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    reorderOfferId: action.payload
                });
            }
        case "setRequest":
            {
                if (state.status !== model/* QUALIFICATION_STATUS.qualifiedForRequest */.w.qualifiedForRequest) {
                    return state;
                }
                return cjs_default()(state, {
                    qualification: {
                        request: action.payload
                    }
                });
            }
        case "qualify":
            {
                if (state.status !== model/* QUALIFICATION_STATUS.answered */.w.answered) {
                    return state;
                }
                if (action.payload.to === "marketplace") {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        status: model/* QUALIFICATION_STATUS.qualifiedForMarketplace */.w.qualifiedForMarketplace,
                        marketplaceUrl: action.payload.url
                    });
                }
                if (action.payload.to === "request") {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        status: model/* QUALIFICATION_STATUS.qualifiedForRequest */.w.qualifiedForRequest
                    });
                }
                return state;
            }
        case "clearBestseller":
            {
                if (state.status === "answering") {
                    var newState = answerQuestion(state, {
                        id: "catering_categories",
                        value: undefined
                    });
                    return initialize(newState, {
                        answers: newState.qualification.answers,
                        selectedCaterer: newState.qualification.selectedCaterer,
                        selectedMenu: undefined
                    });
                }
                return state;
            }
        case "selectBestseller":
            {
                if (state.status === "answering") {
                    var newState1 = answerQuestion(state, {
                        id: "catering_categories",
                        value: undefined
                    });
                    var answers = newState1.qualification.answers;
                    return initialize(newState1, {
                        answers: answers,
                        selectedCaterer: newState1.qualification.selectedCaterer,
                        selectedMenu: action.payload
                    });
                }
                return state;
            }
        case "setCustomerTierExperiment":
            {
                var variation = action.payload;
                if (state.status !== "answering") {
                    return state;
                }
                var lastStep = state.qualification.steps[state.qualification.steps.length - 1];
                if (variation.id === ablyft/* EXPERIMENT.customerTierABC.variations.original.id */.Op.customerTierABC.variations.original.id) {
                    var isAlreadyCorrect = lastStep.id === "dietary_restrictions";
                    if (isAlreadyCorrect) {
                        return state;
                    }
                    var newSteps = (0,_to_consumable_array/* default */.Z)(state.qualification.steps);
                    newSteps.pop();
                    var progressPercentage = getStepIndexAndPercentage(state.qualification.step, newSteps).progressPercentage;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification), {
                            steps: newSteps,
                            progressPercentage: progressPercentage
                        })
                    });
                }
                if (variation.id === ablyft/* EXPERIMENT.customerTierABC.variations.variationB.id */.Op.customerTierABC.variations.variationB.id || variation.id === ablyft/* EXPERIMENT.customerTierABC.variations.variationC.id */.Op.customerTierABC.variations.variationC.id) {
                    var isAlreadyCorrect1 = lastStep.id === schema_steps/* steps.customerTier.id */.S6.customerTier.id;
                    if (isAlreadyCorrect1) {
                        return state;
                    }
                    if (state.qualification.steps.find(function(param) {
                        var id = param.id;
                        return id === schema_steps/* steps.customerTier.id */.S6.customerTier.id;
                    })) {
                        return state;
                    }
                    var newSteps1 = (0,_to_consumable_array/* default */.Z)(state.qualification.steps);
                    newSteps1.push({
                        id: schema_steps/* steps.customerTier.id */.S6.customerTier.id
                    });
                    var progressPercentage1 = getStepIndexAndPercentage(state.qualification.step, newSteps1).progressPercentage;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification), {
                            steps: (0,_to_consumable_array/* default */.Z)(state.qualification.steps).concat([
                                schema_steps/* steps.customerTier */.S6.customerTier
                            ]),
                            progressPercentage: progressPercentage1
                        })
                    });
                }
                return state;
            }
        case "addRareCustomerTierStep":
            {
                if (state.status !== "answering") {
                    return state;
                }
                if (state.qualification.steps.find(function(param) {
                    var id = param.id;
                    return id === schema_steps/* steps.rareCustomerTierStep.id */.S6.rareCustomerTierStep.id;
                })) {
                    return state;
                }
                var newSteps2 = (0,_to_consumable_array/* default */.Z)(state.qualification.steps).concat([
                    schema_steps/* steps.rareCustomerTierStep */.S6.rareCustomerTierStep, 
                ]);
                var progressPercentage2 = getStepIndexAndPercentage(state.qualification.step, newSteps2).progressPercentage;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification), {
                        steps: newSteps2,
                        progressPercentage: progressPercentage2
                    })
                });
            }
        case "removeRareCustomerTierStep":
            {
                if (state.status !== "answering") {
                    return state;
                }
                var newSteps3 = (0,_to_consumable_array/* default */.Z)(state.qualification.steps.filter(function(step) {
                    return step.id != schema_steps/* steps.rareCustomerTierStep.id */.S6.rareCustomerTierStep.id;
                }));
                var progressPercentage3 = getStepIndexAndPercentage(state.qualification.step, newSteps3).progressPercentage;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    qualification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.qualification), {
                        steps: (0,_to_consumable_array/* default */.Z)(state.qualification.steps.filter(function(step) {
                            return step.id != schema_steps/* steps.rareCustomerTierStep.id */.S6.rareCustomerTierStep.id;
                        })),
                        progressPercentage: progressPercentage3
                    })
                });
            }
        default:
            {
                var _exhaustiveCheck = action;
                return state;
            }
    }
};
function getActions(dispatch) {
    return {
        answerQuestion: function(questionId, answer, options) {
            return dispatch({
                type: "answerQuestion",
                payload: {
                    id: questionId,
                    value: answer,
                    options: options || {}
                }
            });
        },
        initialize: function(options) {
            return dispatch({
                type: "initialize",
                payload: options || {}
            });
        },
        nextStep: function() {
            return dispatch({
                type: "nextStep"
            });
        },
        prevStep: function() {
            return dispatch({
                type: "prevStep"
            });
        },
        reset: function() {
            return dispatch({
                type: "reset"
            });
        },
        selectBestseller: function(bestseller) {
            return dispatch({
                type: "selectBestseller",
                payload: bestseller
            });
        },
        clearBestseller: function() {
            return dispatch({
                type: "clearBestseller"
            });
        },
        setQuestion: function(questionId) {
            return dispatch({
                type: "setQuestion",
                payload: questionId
            });
        },
        setReorderOfferId: function(offerId) {
            return dispatch({
                type: "setReorderOfferId",
                payload: offerId
            });
        },
        setRequest: function(requestFormData) {
            return dispatch({
                type: "setRequest",
                payload: requestFormData
            });
        },
        qualify: function(qualified) {
            return dispatch({
                type: "qualify",
                payload: qualified
            });
        },
        setCustomerTierExperiment: function(variation) {
            return dispatch({
                type: "setCustomerTierExperiment",
                payload: variation
            });
        },
        addRareCustomerTierStep: function() {
            return dispatch({
                type: "addRareCustomerTierStep"
            });
        },
        removeRareCustomerTierStep: function() {
            return dispatch({
                type: "removeRareCustomerTierStep"
            });
        }
    };
}

// EXTERNAL MODULE: ./src/qualification/hooks/useCurrentUser.ts + 1 modules
var useCurrentUser = __webpack_require__(866);
// EXTERNAL MODULE: ./src/qualification/hooks/useQualifyUser.ts + 2 modules
var useQualifyUser = __webpack_require__(55351);
// EXTERNAL MODULE: ./src/qualification/schema/questions/customerTierQuestion.ts
var customerTierQuestion = __webpack_require__(30812);
;// CONCATENATED MODULE: ./src/qualification/context/useTierExperiment.ts





var useTierExperiment = function(state, actions) {
    var user = (0,useCurrentUser/* default */.Z)();
    var totalBudget = state.status === "answering" && state.qualification.answers.caterer_minimum_order_value || 0;
    var MAX_BUDGET_FOR_CUSTOMER_TIER_EXPERIMENT = 5000;
    var isLoggedIn = !!user.currentUserAccount;
    var currentStep = state.status === "answering" ? state.qualification.step.id : null;
    var isQualifiedForCustomerTierExperiment = !isLoggedIn && state.status === "answering" && currentStep === "dietary_restrictions" && totalBudget < MAX_BUDGET_FOR_CUSTOMER_TIER_EXPERIMENT && (0,useQualifyUser/* isQualifiedForContactForm */.a)({
        user: user.currentUserAccount,
        answers: state.qualification.answers,
        selectedCaterer: state.qualification.selectedCaterer
    });
    var isQualifiedForCustomerTierExperimentRef = (0,react.useRef)(isQualifiedForCustomerTierExperiment);
    isQualifiedForCustomerTierExperimentRef.current = isQualifiedForCustomerTierExperiment;
    var ref = (0,react.useState)(isQualifiedForCustomerTierExperiment ? true : false), isTierExperimentInitialized = ref[0], setTierExperimentInitialized = ref[1];
    var isInitializedRef = (0,react.useRef)(isTierExperimentInitialized);
    isInitializedRef.current = isTierExperimentInitialized;
    var currentStepRef = (0,react.useRef)(currentStep);
    currentStepRef.current = currentStep;
    var handleExperiment = (0,react.useCallback)(function(isQualified, variationId) {
        if (!isQualified || !window.ablyft) {
            setTierExperimentInitialized(true);
            return;
        }
        var variation = Object.values(ablyft/* EXPERIMENT.customerTierABC.variations */.Op.customerTierABC.variations).find(function(v) {
            return v.id === variationId;
        });
        if (variation) {
            if (variation.id === ablyft/* EXPERIMENT.customerTierABC.variations.original.id */.Op.customerTierABC.variations.original.id) {
                actions.answerQuestion("customer_tier", customerTierQuestion/* CUSTOMER_TIER_CONTROL_VALUE */.Iv);
            }
            actions.setCustomerTierExperiment(variation);
            setTierExperimentInitialized(true);
        }
    }, [
        actions
    ]);
    (0,react.useEffect)(function initializeTierExperiment() {
        if (currentStep !== "dietary_restrictions") {
            return;
        }
        if (!window.ablyft || !isQualifiedForCustomerTierExperiment) {
            setTierExperimentInitialized(true);
            return;
        }
        if (!isTierExperimentInitialized) {
            setTimeout(function() {
                if (isInitializedRef.current || currentStepRef.current !== "dietary_restrictions") {
                    return;
                }
                // Checking the variations would be unnecessary here, but the experimentViewed event is not fired on preview deploymewnts
                // So it's only a fallback for the preview deployment
                var variation = null;
                if ((0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.original */.Op.customerTierABC.variations.original)) {
                    variation = ablyft/* EXPERIMENT.customerTierABC.variations.original */.Op.customerTierABC.variations.original;
                }
                if ((0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationB */.Op.customerTierABC.variations.variationB)) {
                    variation = ablyft/* EXPERIMENT.customerTierABC.variations.variationB */.Op.customerTierABC.variations.variationB;
                }
                if ((0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationC */.Op.customerTierABC.variations.variationC)) {
                    variation = ablyft/* EXPERIMENT.customerTierABC.variations.variationC */.Op.customerTierABC.variations.variationC;
                }
                if (variation) {
                    handleExperiment(isQualifiedForCustomerTierExperimentRef.current, variation.id);
                }
                setTierExperimentInitialized(true);
            }, 1500);
        }
    }, [
        actions,
        currentStep,
        handleExperiment,
        isQualifiedForCustomerTierExperiment,
        isTierExperimentInitialized, 
    ]);
    (0,react.useEffect)(function() {
        if (currentStep === "people_count_and_budget") {
            setTierExperimentInitialized(false);
        }
    }, [
        currentStep,
        actions
    ]);
    (0,react.useEffect)(function() {
        var handleExperimentEvent = function(e) {
            var isCustomerTierExperiment = e.detail.experimentId === ablyft/* EXPERIMENT.customerTierABC.id */.Op.customerTierABC.id;
            if (isCustomerTierExperiment) {
                handleExperiment(isQualifiedForCustomerTierExperiment, e.detail.variationId);
            }
        };
        //@ts-expect-error untyped event
        document.addEventListener("viewedExperiment", handleExperimentEvent);
        return function() {
            //@ts-expect-error untyped event
            document.removeEventListener("viewedExperiment", handleExperimentEvent);
        };
    }, [
        isQualifiedForCustomerTierExperiment,
        handleExperiment,
        actions
    ]);
    (0,react.useEffect)(function() {
        if (state.status === "answering" && state.qualification.step.id === "dietary_restrictions") {
            var ref;
            if (!isQualifiedForCustomerTierExperiment && ((ref = state.qualification.variations) === null || ref === void 0 ? void 0 : ref.length)) {
                actions.setCustomerTierExperiment(ablyft/* EXPERIMENT.customerTierABC.variations.original */.Op.customerTierABC.variations.original);
            }
        }
    }, [
        actions,
        isQualifiedForCustomerTierExperiment,
        state
    ]);
    return {
        isQualifiedForCustomerTierExperiment: isQualifiedForCustomerTierExperiment,
        isTierExperimentInitialized: isTierExperimentInitialized
    };
};

;// CONCATENATED MODULE: ./src/qualification/hooks/useStorageReducer.ts


var initializer = function(key, storage, isInvalid) {
    return function(initial) {
        var storageFn = storage === "localStorage" ? localStorage : sessionStorage;
        var stored = storageFn.getItem(key);
        if (!stored) return initial;
        var parsedData = (0,_object_spread/* default */.Z)({}, JSON.parse(stored));
        if (isInvalid) {
            return isInvalid(parsedData) ? initial : parsedData;
        }
        return parsedData;
    };
};
var useStorageReducer = function(reducer, initialState, options) {
    var ref = (0,react.useReducer)(reducer, initialState, options.storage && "object" !== "undefined" ? initializer(options.key, options.storage, options.isInvalid) : function() {
        return initialState;
    }), state = ref[0], dispatch = ref[1];
    var clearValue = (0,react.useCallback)(function() {
        if (options.storage && "object" !== "undefined") {
            var storageFn = options.storage === "localStorage" ? localStorage : sessionStorage;
            storageFn.removeItem(options.key);
        }
    }, [
        options
    ]);
    (0,react.useEffect)(function() {
        if (options.storage && "object" !== "undefined") {
            var storageFn = options.storage === "localStorage" ? localStorage : sessionStorage;
            storageFn.setItem(options.key, JSON.stringify(state));
        }
    }, [
        state
    ]);
    return [
        state,
        dispatch,
        clearValue
    ];
};
var createStorageReducer = function(storage, isInvalid) {
    return function(reducer, initialState, key) {
        return useStorageReducer(reducer, initialState, {
            key: key,
            storage: storage,
            isInvalid: isInvalid
        });
    };
};
var useSessionReducer = createStorageReducer("sessionStorage");
var useLocalReducer = createStorageReducer("localStorage");

// EXTERNAL MODULE: ./src/qualification/context/useQualification.ts + 1 modules
var useQualification = __webpack_require__(88294);
;// CONCATENATED MODULE: ./src/qualification/context/index.tsx
















var QualificationContext = /*#__PURE__*/ (0,react.createContext)(null);
/*
 * PROVIDER
 */ var QualificationProvider = function(_param) {
    var children = _param.children, initialized = _param.initialized, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "initialized"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(useStorageReducer(qualificationReducer, initialized ? initialize(model/* DEFAULT_QUALIFICATION_STATE */.$, typeof initialized === "boolean" ? undefined : initialized) : model/* DEFAULT_QUALIFICATION_STATE */.$, "storageKey" in props ? {
        key: props.storageKey,
        isInvalid: isDataInStorageInvalid,
        storage: props.storage
    } : {
        storage: null,
        isInvalid: isDataInStorageInvalid
    }), 3), state = ref[0], dispatch = ref[1], clearSaved = ref[2];
    (0,react.useEffect)(function() {
        if (initialized) {
            var initialData = typeof initialized === "object" ? initialized : {};
            actions.initialize((0,_object_spread/* default */.Z)({}, initialData));
        }
    }, [
        initialized
    ]);
    var actions = (0,react.useMemo)(function() {
        return getActions(dispatch);
    }, []);
    (0,useCurrentUser/* default */.Z)();
    var answers = "qualification" in state ? state.qualification.answers : null;
    var errors = "qualification" in state && "errors" in state.qualification ? state.qualification.errors : null;
    var answerOf = (0,react.useCallback)(function(questionId) {
        if (answers) {
            return answers[questionId];
        }
    }, [
        answers
    ]);
    var errorsOfQuestion = (0,react.useCallback)(function(questionId) {
        if (!errors) {
            return [];
        }
        return errors[questionId] || [];
    }, [
        errors
    ]);
    var errorsOfStep = (0,react.useCallback)(function(stepId) {
        if (!errors) {
            return [];
        }
        var isAnswered = schema_steps/* SCHEMA_STEPS */.C$[stepId].questions.map(function(question) {
            return (answers === null || answers === void 0 ? void 0 : answers[question.id]) || [];
        }).flat(Infinity).length;
        if (!isAnswered) return [];
        var questionErrors = schema_steps/* SCHEMA_STEPS */.C$[stepId].questions.map(function(question) {
            return errors[question.id] || [];
        }).filter(function(array) {
            return array.length > 0;
        }).flat();
        return questionErrors || [];
    }, [
        errors,
        answers
    ]);
    // Answer default values
    (0,react.useEffect)(function() {
        if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
            return;
        }
        var currentStepId = state.qualification.step.id;
        var step = schema_steps/* SCHEMA_STEPS */.C$[currentStepId];
        step.questions.forEach(function(child) {
            return answerDefaultValue(child, state, actions);
        });
    }, [
        state,
        answerOf,
        actions
    ]);
    var ref1 = useTierExperiment(state, actions), isTierExperimentInitialized = ref1.isTierExperimentInitialized, isQualifiedForCustomerTierExperiment = ref1.isQualifiedForCustomerTierExperiment;
    var currentStep = state.status === "answering" && state.qualification.step.id;
    var canContinue = (0,react.useMemo)(function() {
        if (currentStep === "dietary_restrictions" && !isTierExperimentInitialized) {
            // Disable the next button, unless the experiment is initialized
            return false;
        }
        return canGoToNextStep(state);
    }, [
        currentStep,
        isTierExperimentInitialized,
        state
    ]);
    var shouldTriggerTierExperimentForABLyft = isQualifiedForCustomerTierExperiment;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QualificationContext.Provider, {
        value: {
            state: state,
            actions: actions,
            clearSaved: clearSaved,
            answerOf: answerOf,
            errorsOfStep: errorsOfStep,
            errorsOf: errorsOfQuestion,
            canContinue: canContinue
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
            display: "contents",
            id: "qualification-provider",
            /* This is used to trigger the experiment on ABLYft's side. 
        The experiment is triggered when it finds a DOM node with a data-exp-customer-tiers attribute  
        Learn more at: https://app.ablyft.com/pages/74419923/edit 
        */ "data-exp-customer-tiers": shouldTriggerTierExperimentForABLyft,
            children: children
        })
    });
};
/*
 * HOC
 */ function withQualificationProvider(props, Component) {
    return function withHOC(componentProps) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(QualificationProvider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, componentProps))
        }));
    };
}
function answerDefaultValue(question, state, actions) {
    if (state.qualification.answers[question.id] !== undefined) {
        return;
    }
    if ("getDefaultValue" in question) {
        var ref;
        var defaultValue = (ref = question.getDefaultValue) === null || ref === void 0 ? void 0 : ref.call(question, {
            answers: state.qualification.answers,
            selectedCaterer: state.qualification.selectedCaterer
        });
        if (defaultValue !== undefined) {
            actions.answerQuestion(question.id, defaultValue);
        }
    }
}
function isDataInStorageInvalid(data) {
    try {
        var validator = yup/* default.object */.Z.object({
            qualification: yup/* default.object */.Z.object({
                steps: yup/* default.array */.Z.array().of(yup/* default.object */.Z.object({
                    id: yup/* default.mixed */.Z.mixed().oneOf(Object.values(schema_steps/* STEP_IDS */.Xb)).required()
                })),
                questions: yup/* default.mixed */.Z.mixed().oneOf([
                    undefined
                ])
            })
        });
        validator.validateSync(data);
        return false;
    } catch (e) {
        return true;
    }
}



/***/ }),

/***/ 91538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ DEFAULT_QUALIFICATION_STATE; },
/* harmony export */   "w": function() { return /* binding */ QUALIFICATION_STATUS; }
/* harmony export */ });
var QUALIFICATION_STATUS = {
    initial: "initial",
    answering: "answering",
    answered: "answered",
    qualifiedForRequest: "qualified-for-request",
    qualifiedForMarketplace: "qualified-for-marketplace"
};
var DEFAULT_QUALIFICATION_STATE = Object.freeze({
    status: QUALIFICATION_STATUS.initial,
    currentUserAccount: null
});


/***/ }),

/***/ 88294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useQualification; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var qualification_context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/context/model.ts
var model = __webpack_require__(91538);
;// CONCATENATED MODULE: ./src/shared/hooks/usePrevious.ts

function usePrevious(value) {
    var ref = (0,react.useRef)();
    (0,react.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}

;// CONCATENATED MODULE: ./src/qualification/context/useQualification.ts




function useQualification() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, onQuestionChange = ref.onQuestionChange, onAllQuestionAnswered = ref.onAllQuestionAnswered;
    var ref1;
    var context = (0,react.useContext)(qualification_context/* QualificationContext */.Bk);
    if (!context) {
        throw new Error("useQualification hook is used outside of it's context provider");
    }
    var status = context.state.status;
    var prevStatus = usePrevious(status);
    var question = status === model/* QUALIFICATION_STATUS.answering */.w.answering ? context.state.qualification.step : undefined;
    var prevQuestionId = usePrevious(status === model/* QUALIFICATION_STATUS.answering */.w.answering ? (ref1 = context.state.qualification.step) === null || ref1 === void 0 ? void 0 : ref1.id : undefined);
    // onAllQuestionAnswered
    (0,react.useEffect)(function() {
        if (status === model/* QUALIFICATION_STATUS.answered */.w.answered && prevStatus !== model/* QUALIFICATION_STATUS.answered */.w.answered && onAllQuestionAnswered) {
            onAllQuestionAnswered(context.state);
        }
    }, [
        status,
        prevStatus
    ]);
    // onQuestionChange
    (0,react.useEffect)(function() {
        if (!onQuestionChange || status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
            return;
        }
        if (prevQuestionId !== (question === null || question === void 0 ? void 0 : question.id)) {
            onQuestionChange(question);
        }
    }, [
        onQuestionChange,
        prevQuestionId,
        question
    ]);
    return context;
}


/***/ }),

/***/ 55351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ isQualifiedForContactForm; },
  "y": function() { return /* binding */ useQualifyUser; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/hooks/useCurrentUser.ts + 1 modules
var useCurrentUser = __webpack_require__(866);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__(93555);
// EXTERNAL MODULE: ./src/shared/helpers/localizedFieldNames.ts
var localizedFieldNames = __webpack_require__(53279);
;// CONCATENATED MODULE: ./src/qualification/services/LocalizedAlgoliaAttributes.js






var LocalizedAlgoliaAttributes = /*#__PURE__*/ function() {
    "use strict";
    function LocalizedAlgoliaAttributes(param) {
        var filters = param.filters, locale = param.locale;
        (0,_class_call_check/* default */.Z)(this, LocalizedAlgoliaAttributes);
        this.filters = filters;
        this.locale = locale;
    }
    (0,_create_class/* default */.Z)(LocalizedAlgoliaAttributes, [
        {
            key: "generateLocalizedFieldValues",
            value: function generateLocalizedFieldValues(attributeName) {
                var _this = this;
                var algoliaLocaleResources = i18n/* localeResources */.jy[(0,i18n/* getFallbackForLocale */.rh)(this.locale)]["common"]["algolia"];
                return Object.entries(algoliaLocaleResources[attributeName]).reduce(function(result, param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                    return (_this.filters[attributeName] || []).includes(key) ? (0,_to_consumable_array/* default */.Z)(result).concat([
                        value
                    ]) : result;
                }, []);
            }
        },
        {
            key: "localizedFieldName",
            value: function localizedFieldName(attributeName) {
                return (0,localizedFieldNames/* algoliaAttributeNameForLocale */.u)(this.locale)(attributeName);
            }
        }
    ]);
    return LocalizedAlgoliaAttributes;
}();
/* harmony default export */ var services_LocalizedAlgoliaAttributes = (LocalizedAlgoliaAttributes);

// EXTERNAL MODULE: ./src/shared/helpers/dates.js
var dates = __webpack_require__(47004);
// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
;// CONCATENATED MODULE: ./src/qualification/services/buildFilteredMarketplaceURL.ts





function buildFilteredMarketplaceURL(answers, locale) {
    var localizedAlgoliaAttributes = new services_LocalizedAlgoliaAttributes({
        filters: answers,
        locale: locale
    });
    var city = answers.city || "berlin";
    var queryParts = {
        qualified: true,
        lng: locale,
        refinementList: (0,_define_property/* default */.Z)({}, localizedAlgoliaAttributes.localizedFieldName("catering_categories"), localizedAlgoliaAttributes.generateLocalizedFieldValues("catering_categories")),
        range: {
            min_order_number: {
                max: answers.min_order_number || 0
            }
        }
    };
    if (answers.event_date) {
        queryParts.event_date = (0,dates/* toUnixTimestamp */.nz)(new Date(answers.event_date));
    }
    queryParts.range.price_per_person = {
        max: (answers.price_per_person || 0) * 100
    };
    return (0,urls/* marketplaceURL */.j5)("/catering/".concat(city, "?").concat((0,lib.stringify)(queryParts)));
}

// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
;// CONCATENATED MODULE: ./src/qualification/hooks/useQualifyUser.ts






var MAX_TIME_BEFORE_REDIRECT = 1800;
function useQualifyUser() {
    var router = (0,next_router.useRouter)();
    var ref = (0,context/* useQualification */._8)(), actions = ref.actions, state = ref.state;
    var currentUserAccount = (0,useCurrentUser/* default */.Z)().currentUserAccount;
    var redirectTimeoutRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var qualify = function qualify() {
            if (qualifiedForContactForm) {
                actions.qualify({
                    to: "request"
                });
            } else {
                actions.qualify({
                    to: "marketplace",
                    url: buildFilteredMarketplaceURL(answers, router.locale)
                });
            }
        };
        var ref;
        if (!("qualification" in state)) {
            return;
        }
        var answers = state.qualification.answers;
        var qualifiedForContactForm = isQualifiedForContactForm({
            answers: answers,
            user: currentUserAccount,
            selectedCaterer: (ref = state.qualification) === null || ref === void 0 ? void 0 : ref.selectedCaterer
        });
        redirectTimeoutRef.current = setTimeout(qualify, Math.random() * MAX_TIME_BEFORE_REDIRECT);
        return function() {
            if (redirectTimeoutRef.current) {
                clearTimeout(redirectTimeoutRef.current);
            }
        };
    }, []);
}
function isQualifiedForContactForm(param) {
    var user = param.user, answers = param.answers, selectedCaterer = param.selectedCaterer;
    var ref, ref1, ref2;
    var isPrivateLeadType = !user && answers.lead_type === constants/* LEAD_TYPE.PRIVATE */.Dy.PRIVATE;
    var isHighBudget = (answers === null || answers === void 0 ? void 0 : answers.caterer_minimum_order_value) && (answers === null || answers === void 0 ? void 0 : answers.caterer_minimum_order_value) >= constants/* MIN_BUDGET */.mC;
    var isLowBudget = !isHighBudget;
    var hasADMProcess = (user === null || user === void 0 ? void 0 : (ref = user.owner) === null || ref === void 0 ? void 0 : ref.admStage) === "account-managed";
    var isManagedAccount = !!(user === null || user === void 0 ? void 0 : (ref1 = user.owner) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.salesforceCustomer) === null || ref2 === void 0 ? void 0 : ref2.isManagedAccount);
    var hasRecurringNeed = !!answers.has_recurring_need;
    if (selectedCaterer) {
        return true;
    }
    if (isPrivateLeadType) {
        return false;
    }
    if (isHighBudget) {
        return true;
    }
    if (isLowBudget) {
        if (hasRecurringNeed) return true;
        if (isManagedAccount) return true;
        if (hasADMProcess) return true;
    }
    return false;
}


/***/ }),

/***/ 92789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JL": function() { return /* binding */ totalBudgetQuestion; },
/* harmony export */   "fk": function() { return /* binding */ pricePerPersonQuestion; }
/* harmony export */ });
/* unused harmony exports DEFAULT_BUDGET_PER_PERSON, MIN_PRICE_PER_PERSON */
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21373);
/* harmony import */ var lib_yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33448);
/* harmony import */ var qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61535);
/* harmony import */ var qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56274);




var DEFAULT_BUDGET_PER_PERSON = 25;
var MIN_PRICE_PER_PERSON = 10;
var pricePerPersonQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_3__/* .createQuestion */ .CB)({
    id: "price_per_person",
    getDefaultValue: function(param) {
        var answers = param.answers;
        var ref;
        if (!((ref = answers.catering_categories) === null || ref === void 0 ? void 0 : ref.length)) {
            return DEFAULT_BUDGET_PER_PERSON;
        }
        var categories = answers.catering_categories || [];
        var hasMultipleCategories = categories.length > 1;
        var category = hasMultipleCategories ? "other" : categories[0] || "other";
        var priceData = qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_2__/* .PRICE_PER_PERSON_OF_CATEGORY */ .TN[category];
        return priceData.defaultPricePerPerson;
    },
    getValidator: function(param) {
        var answers = param.answers, isManagedAccount = param.isManagedAccount;
        var categories = answers.catering_categories || [];
        var hasMultipleCategories = categories.length > 1;
        var category = hasMultipleCategories ? "other" : categories[0] || "other";
        var minPrice = isManagedAccount ? 1 : qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_2__/* .PRICE_PER_PERSON_OF_CATEGORY */ .TN[category].minPricePerPerson;
        return lib_yup__WEBPACK_IMPORTED_MODULE_1__/* ["default"].number */ .Z.number().required().min(minPrice, i18next__WEBPACK_IMPORTED_MODULE_0__/* ["default"].t */ .Z.t("qualification:validations.pricePerPerson.lowForCategory", {
            budget: minPrice,
            category: i18next__WEBPACK_IMPORTED_MODULE_0__/* ["default"].t */ .Z.t("qualification:validations.pricePerPerson.category.".concat(category))
        })).max(500);
    },
    content: {
        titleEn: "Per person // Net value",
        titleDe: "Pro Person // Netto",
        assistiveTextEn: "Per person // Net value",
        assistiveTextDe: "Pro Person // Netto",
        placeholderDe: "z.B. 12",
        placeholderEn: "e.g. 12"
    }
});
var totalBudgetQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_3__/* .createQuestion */ .CB)({
    id: "caterer_minimum_order_value",
    getValidator: function(param) {
        var selectedCaterer = param.selectedCaterer;
        var minimumOrderPrice = selectedCaterer ? selectedCaterer.minimum_order_value / 100 : 0;
        return lib_yup__WEBPACK_IMPORTED_MODULE_1__/* ["default"].number */ .Z.number().min(minimumOrderPrice).required();
    },
    content: {
        titleEn: "Net value",
        titleDe: "Netto",
        assistiveTextEn: "Net value",
        assistiveTextDe: "Netto",
        placeholderDe: "z.B. 1200",
        placeholderEn: "e.g. 1200"
    }
});


/***/ }),

/***/ 30812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$X": function() { return /* binding */ customerTier; },
/* harmony export */   "$q": function() { return /* binding */ rareCustomerTierQuestion; },
/* harmony export */   "Iv": function() { return /* binding */ CUSTOMER_TIER_CONTROL_VALUE; },
/* harmony export */   "MX": function() { return /* binding */ customerTierQuestion; }
/* harmony export */ });
/* unused harmony exports CUSTOMER_TIER_B_VALUES, CUSTOMER_TIER_C_VALUES, FREQUENCY_CUSTOMER_TIER_C_VALUES */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var lib_yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33448);
/* harmony import */ var qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56274);



var CUSTOMER_TIER_CONTROL_VALUE = "control-group";
var CUSTOMER_TIER_B_VALUES = (/* unused pure expression or super */ null && ([
    "single-use-b",
    "recurring-request-b",
    "food-program-b", 
]));
var CUSTOMER_TIER_C_VALUES = (/* unused pure expression or super */ null && ([
    "single-use-c",
    "recurring-request-c",
    "food-program-c", 
]));
var FREQUENCY_CUSTOMER_TIER_C_VALUES = [
    "rare-b",
    "rare-c-ir",
    "regular",
    "frequent", 
];
var customerTier = {
    controlGroup: "control-group",
    singleUseB: "single-use-b",
    recurringB: "recurring-request-b",
    foodProgramB: "food-program-b",
    singleUseC: "single-use-c",
    recurringC: "recurring-request-c",
    foodProgramC: "food-program-c",
    rareV1: "rare-b",
    rareV2: "rare-c-ir",
    regular: "regular",
    frequent: "frequent"
};
var customerTierQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__/* .createQuestion */ .CB)({
    id: "customer_tier",
    getValidator: function() {
        return lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mixed */ .Z.mixed().oneOf((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(FREQUENCY_CUSTOMER_TIER_C_VALUES)).required();
    },
    content: {
        titleEn: "Customer tier",
        titleDe: "Kundengruppe"
    }
});
var rareCustomerTierQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__/* .createQuestion */ .CB)({
    id: "rare_customer_tier",
    getValidator: function() {
        return lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].string */ .Z.string().nullable();
    },
    content: {
        titleEn: "Customer tier",
        titleDe: "Kundengruppe"
    }
});


/***/ }),

/***/ 69307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JF": function() { return /* binding */ DEFAULT_DIETARY_PERCENTAGE; },
/* harmony export */   "L5": function() { return /* binding */ numberOfCarnivoresQuestion; },
/* harmony export */   "dJ": function() { return /* binding */ numberOfVegansQuestion; },
/* harmony export */   "sN": function() { return /* binding */ numberOfVegetariansQuestion; }
/* harmony export */ });
/* harmony import */ var lib_yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33448);
/* harmony import */ var qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56274);


var DEFAULT_DIETARY_PERCENTAGE = {
    carnivore: 0.3,
    vegetarian: 0.5,
    vegan: 0.2
};
var numberOfVegetariansQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__/* .createQuestion */ .CB)({
    id: "number_of_vegetarians",
    getValidator: function() {
        return lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].number */ .Z.number().required().min(0);
    },
    content: {
        titleEn: "Vegetarians",
        titleDe: "Vegetarier",
        image: "/artifacts/images/survey/dietary_restrictions/vegetarian.webp"
    }
});
var numberOfVegansQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__/* .createQuestion */ .CB)({
    id: "number_of_vegans",
    getValidator: function() {
        return lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].number */ .Z.number().required().min(0);
    },
    content: {
        titleEn: "Vegans",
        titleDe: "Veganer",
        image: "/artifacts/images/survey/dietary_restrictions/vegan.webp"
    }
});
var numberOfCarnivoresQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__/* .createQuestion */ .CB)({
    id: "number_of_carnivore",
    getValidator: function() {
        return lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].number */ .Z.number().required().min(0);
    },
    content: {
        titleEn: "Carnivore",
        titleDe: "Fleischesser",
        image: "/artifacts/images/survey/dietary_restrictions/carnivore.webp"
    }
});


/***/ }),

/***/ 85785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cB": function() { return /* binding */ isRecurringQuestion; },
/* harmony export */   "fh": function() { return /* binding */ isMultipleDaysQuestion; },
/* harmony export */   "n0": function() { return /* binding */ DEFAULT_LEAD_DAYS; },
/* harmony export */   "uO": function() { return /* binding */ dateQuestion; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82670);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77349);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20466);
/* harmony import */ var lib_yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33448);
/* harmony import */ var qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56274);




var DEFAULT_LEAD_DAYS = 2;
var isMultipleDaysQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__/* .createQuestion */ .CB)({
    id: "is_multi_day",
    getDefaultValue: function() {
        return false;
    },
    getValidator: function() {
        return lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].boolean */ .Z.boolean();
    }
});
var isRecurringQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__/* .createQuestion */ .CB)({
    id: "has_recurring_need",
    getDefaultValue: function() {
        return false;
    },
    condition: function(isLoggedIn) {
        return !isLoggedIn;
    },
    getValidator: function() {
        return lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].boolean */ .Z.boolean();
    }
});
var dateQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__/* .createDateQuestion */ .CX)({
    id: "event_date",
    getValidator: function(param) {
        var selectedCaterer = param.selectedCaterer;
        var leadDays = selectedCaterer ? selectedCaterer.numeric_lead_time : DEFAULT_LEAD_DAYS;
        var minDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Date(), leadDays - 1);
        var validator = lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].date */ .Z.date().min(minDate).required();
        if (selectedCaterer) {
            var weeklyAvailability = [
                selectedCaterer.available_on_monday,
                selectedCaterer.available_on_tuesday,
                selectedCaterer.available_on_wednesday,
                selectedCaterer.available_on_thursday,
                selectedCaterer.available_on_friday,
                selectedCaterer.available_on_saturday,
                selectedCaterer.available_on_sunday, 
            ];
            var isAvailableEveryDay = weeklyAvailability.every(function(isAvailable) {
                return isAvailable === true;
            });
            if (!isAvailableEveryDay) {
                validator = validator.test("is-caterer-available", function(date) {
                    if (!(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date, Date)) {
                        return false;
                    }
                    var weekDay = (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(date);
                    return !!weeklyAvailability[weekDay];
                });
            }
        }
        return validator;
    },
    getAttributes: function(param) {
        var selectedCaterer = param.selectedCaterer;
        var leadDays = selectedCaterer ? selectedCaterer.numeric_lead_time : DEFAULT_LEAD_DAYS;
        return {
            minDate: {
                leadTimeDays: leadDays,
                messageEn: "The lead time must be at least ".concat(leadDays, " days"),
                messageDe: "Die Vorlaufzeit muss mind. ".concat(leadDays, " Tage betragen")
            }
        };
    }
});


/***/ }),

/***/ 89121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ questions; },
/* harmony export */   "x": function() { return /* binding */ SCHEMA_QUESTIONS; }
/* harmony export */ });
/* harmony import */ var qualification_schema_questions_budgetQuestion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92789);
/* harmony import */ var qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61535);
/* harmony import */ var qualification_schema_questions_cityQuestion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26407);
/* harmony import */ var qualification_schema_questions_customerTierQuestion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30812);
/* harmony import */ var qualification_schema_questions_dietaryRestrictionsQuestion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69307);
/* harmony import */ var qualification_schema_questions_eventDateQuestion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85785);
/* harmony import */ var qualification_schema_questions_leadTypeQuestion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62798);
/* harmony import */ var qualification_schema_questions_peopleCountQuestion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65231);








var questions = {
    leadType: qualification_schema_questions_leadTypeQuestion__WEBPACK_IMPORTED_MODULE_6__/* .leadTypeQuestion */ .jW,
    peopleCount: qualification_schema_questions_peopleCountQuestion__WEBPACK_IMPORTED_MODULE_7__/* .peopleCountQuestion */ .m,
    totalBudget: qualification_schema_questions_budgetQuestion__WEBPACK_IMPORTED_MODULE_0__/* .totalBudgetQuestion */ .JL,
    pricePerPerson: qualification_schema_questions_budgetQuestion__WEBPACK_IMPORTED_MODULE_0__/* .pricePerPersonQuestion */ .fk,
    city: qualification_schema_questions_cityQuestion__WEBPACK_IMPORTED_MODULE_2__/* .cityQuestion */ .Vv,
    date: qualification_schema_questions_eventDateQuestion__WEBPACK_IMPORTED_MODULE_5__/* .dateQuestion */ .uO,
    isRecurring: qualification_schema_questions_eventDateQuestion__WEBPACK_IMPORTED_MODULE_5__/* .isRecurringQuestion */ .cB,
    isMultipleDays: qualification_schema_questions_eventDateQuestion__WEBPACK_IMPORTED_MODULE_5__/* .isMultipleDaysQuestion */ .fh,
    cateringCategories: qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_1__/* .cateringCategoriesQuestion */ .BN,
    numberOfVegans: qualification_schema_questions_dietaryRestrictionsQuestion__WEBPACK_IMPORTED_MODULE_4__/* .numberOfVegansQuestion */ .dJ,
    numberOfVegetarians: qualification_schema_questions_dietaryRestrictionsQuestion__WEBPACK_IMPORTED_MODULE_4__/* .numberOfVegetariansQuestion */ .sN,
    numberOfCarnivore: qualification_schema_questions_dietaryRestrictionsQuestion__WEBPACK_IMPORTED_MODULE_4__/* .numberOfCarnivoresQuestion */ .L5,
    customerTier: qualification_schema_questions_customerTierQuestion__WEBPACK_IMPORTED_MODULE_3__/* .customerTierQuestion */ .MX,
    rareCustomerTierQuestion: qualification_schema_questions_customerTierQuestion__WEBPACK_IMPORTED_MODULE_3__/* .rareCustomerTierQuestion */ .$q
};
/**
 * A record of questions where their ids are the keys
 */ var SCHEMA_QUESTIONS = createQuestions({
    lead_type: qualification_schema_questions_leadTypeQuestion__WEBPACK_IMPORTED_MODULE_6__/* .leadTypeQuestion */ .jW,
    min_order_number: qualification_schema_questions_peopleCountQuestion__WEBPACK_IMPORTED_MODULE_7__/* .peopleCountQuestion */ .m,
    caterer_minimum_order_value: qualification_schema_questions_budgetQuestion__WEBPACK_IMPORTED_MODULE_0__/* .totalBudgetQuestion */ .JL,
    price_per_person: qualification_schema_questions_budgetQuestion__WEBPACK_IMPORTED_MODULE_0__/* .pricePerPersonQuestion */ .fk,
    city: qualification_schema_questions_cityQuestion__WEBPACK_IMPORTED_MODULE_2__/* .cityQuestion */ .Vv,
    event_date: qualification_schema_questions_eventDateQuestion__WEBPACK_IMPORTED_MODULE_5__/* .dateQuestion */ .uO,
    has_recurring_need: qualification_schema_questions_eventDateQuestion__WEBPACK_IMPORTED_MODULE_5__/* .isRecurringQuestion */ .cB,
    is_multi_day: qualification_schema_questions_eventDateQuestion__WEBPACK_IMPORTED_MODULE_5__/* .isMultipleDaysQuestion */ .fh,
    catering_categories: qualification_schema_questions_cateringCategoriesQuestion__WEBPACK_IMPORTED_MODULE_1__/* .cateringCategoriesQuestion */ .BN,
    number_of_vegans: qualification_schema_questions_dietaryRestrictionsQuestion__WEBPACK_IMPORTED_MODULE_4__/* .numberOfVegansQuestion */ .dJ,
    number_of_vegetarians: qualification_schema_questions_dietaryRestrictionsQuestion__WEBPACK_IMPORTED_MODULE_4__/* .numberOfVegetariansQuestion */ .sN,
    number_of_carnivore: qualification_schema_questions_dietaryRestrictionsQuestion__WEBPACK_IMPORTED_MODULE_4__/* .numberOfCarnivoresQuestion */ .L5,
    customer_tier: qualification_schema_questions_customerTierQuestion__WEBPACK_IMPORTED_MODULE_3__/* .customerTierQuestion */ .MX,
    rare_customer_tier: qualification_schema_questions_customerTierQuestion__WEBPACK_IMPORTED_MODULE_3__/* .rareCustomerTierQuestion */ .$q
});
function createQuestions(obj) {
    return obj;
}


/***/ }),

/***/ 62798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__": function() { return /* binding */ LEAD_TYPE_ITEMS; },
/* harmony export */   "jW": function() { return /* binding */ leadTypeQuestion; }
/* harmony export */ });
/* unused harmony export LEAD_TYPES */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var lib_yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33448);
/* harmony import */ var qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56274);



var LEAD_TYPES = [
    "private",
    "business"
];
var LEAD_TYPE_ITEMS = [
    {
        labelEn: "Private",
        labelDe: "Privat",
        value: "private",
        image: "/artifacts/images/survey/lead_type/private_lead.webp"
    },
    {
        labelEn: "Business",
        labelDe: "Gesch\xe4ftlich",
        value: "business",
        image: "/artifacts/images/survey/lead_type/business_lead.webp"
    }, 
];
var leadTypeQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__/* .createSelectorQuestion */ .iX)({
    id: "lead_type",
    getDefaultValue: function() {
        return "business";
    },
    getValidator: function() {
        return lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mixed */ .Z.mixed().oneOf((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(LEAD_TYPES)).required();
    },
    condition: function(isLoggedIn) {
        return !isLoggedIn;
    },
    content: {
        titleEn: "Is it for a private or business event?",
        titleDe: "Ist es ein privater oder ein gesch\xe4ftlicher Anlass?"
    },
    getItems: function() {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(LEAD_TYPE_ITEMS);
    }
});


/***/ }),

/***/ 65231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ peopleCountQuestion; }
/* harmony export */ });
/* harmony import */ var lib_yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33448);
/* harmony import */ var qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56274);


var peopleCountQuestion = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_1__/* .createQuestion */ .CB)({
    id: "min_order_number",
    getValidator: function() {
        return lib_yup__WEBPACK_IMPORTED_MODULE_0__/* ["default"].number */ .Z.number().min(1).required();
    },
    content: {
        titleEn: "How many people will be served?",
        titleDe: "Wie viele Personen sollen ca. verk\xf6stigt werden?"
    },
    suggestions: [
        {
            labelEn: "10 People",
            labelDe: "10 Personen",
            value: 10
        },
        {
            labelEn: "25 People",
            labelDe: "25 Personen",
            value: 25
        },
        {
            labelEn: "50 People",
            labelDe: "50 Personen",
            value: 50
        },
        {
            labelEn: "100 People",
            labelDe: "100 Personen",
            value: 100
        }, 
    ]
});


/***/ }),

/***/ 82546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C$": function() { return /* binding */ SCHEMA_STEPS; },
/* harmony export */   "S6": function() { return /* binding */ steps; },
/* harmony export */   "Xb": function() { return /* binding */ STEP_IDS; }
/* harmony export */ });
/* unused harmony exports cityStep, cateringCategoryStep, eventDateAndLeadTypeStep, dietaryRestrictionStep, customerTierStep, rareCustomerTierStep, budgetAndPeopleCountStep */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var lib_ablyft__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49423);
/* harmony import */ var qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89121);
/* harmony import */ var qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56274);




var STEP_IDS = {
    city: "city",
    cateringCategories: "catering_categories",
    eventDate: "event_date",
    dietaryRestrictions: "dietary_restrictions",
    budgetAndPeopleCount: "people_count_and_budget",
    rareCustomerTier: "rare_customer_tier",
    customerTier: "customer_tier"
};
var cityStep = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_2__/* .createStep */ .yW)({
    id: STEP_IDS.city,
    questions: [
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.city */ .X.city
    ],
    content: {
        titleEn: "Select your City",
        titleDe: "W\xe4hle deine Stadt"
    }
});
var cateringCategoryStep = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_2__/* .createStep */ .yW)({
    id: STEP_IDS.cateringCategories,
    questions: [
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.cateringCategories */ .X.cateringCategories
    ],
    content: {
        titleEn: "What type of Catering do you need?",
        titleDe: "Welche Art von Catering ben\xf6tigst du?",
        subtitleEn: "Multiple selection possible",
        subtitleDe: "Mehrfachauswahl m\xf6glich"
    }
});
var eventDateAndLeadTypeStep = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_2__/* .createStep */ .yW)({
    id: STEP_IDS.eventDate,
    questions: [
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.date */ .X.date,
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.isRecurring */ .X.isRecurring,
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.leadType */ .X.leadType,
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.isMultipleDays */ .X.isMultipleDays, 
    ],
    content: {
        titleEn: "When will your event take place?",
        titleDe: "Wann findet dein Event statt?",
        assistiveTextEn: "When is your event?",
        assistiveTextDe: "Wann ist dein Event?"
    }
});
var dietaryRestrictionStep = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_2__/* .createStep */ .yW)({
    id: STEP_IDS.dietaryRestrictions,
    questions: [
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.numberOfVegetarians */ .X.numberOfVegetarians,
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.numberOfVegans */ .X.numberOfVegans,
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.numberOfCarnivore */ .X.numberOfCarnivore, 
    ],
    content: {
        titleEn: "What should be the distribution of the diets?",
        titleDe: "Wie soll die Verteilung der Ern\xe4hrungsformen sein?",
        subtitleEn: "Based on our catering experience, 50% vegetarian, 30% meat and 20% vegan is an optimal distribution. You can adjust these values now or later.",
        subtitleDe: "Basierend auf unserer Catering Erfahrung sind 50% vegetarisch, 30% Fleisch und 20% vegan eine optimale Verteilung. Du kannst diese Werte jetzt oder auch sp\xe4ter anpassen.",
        mobileSubtitleEn: "Based on our experience, this is an ideal distribution, you can adjust these values now or later.",
        mobileSubtitleDe: "Basierend aus unserer Erfahrung ist dies eine ideale Verteilung, du kannst diese Werte jetzt oder auch sp\xe4ter anpassen."
    }
});
var customerTierStep = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_2__/* .createStep */ .yW)({
    id: STEP_IDS.customerTier,
    questions: [
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.customerTier */ .X.customerTier
    ],
    content: {
        titleEn: "heycater! specializes in customers with regular catering needs",
        titleDe: "heycater! ist spezialisiert auf Kunden mit regelm\xe4\xdfigem Cateringbedarf"
    }
});
var rareCustomerTierStep = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_2__/* .createStep */ .yW)({
    id: STEP_IDS.rareCustomerTier,
    questions: [
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.rareCustomerTierQuestion */ .X.rareCustomerTierQuestion
    ],
    content: {
        titleEn: (0,lib_ablyft__WEBPACK_IMPORTED_MODULE_0__/* .isVariationActive */ .s_)(lib_ablyft__WEBPACK_IMPORTED_MODULE_0__/* .EXPERIMENT.customerTierABC.variations.variationB */ .Op.customerTierABC.variations.variationB) ? "You don't have regular needs? No problem!" : "",
        titleDe: (0,lib_ablyft__WEBPACK_IMPORTED_MODULE_0__/* .isVariationActive */ .s_)(lib_ablyft__WEBPACK_IMPORTED_MODULE_0__/* .EXPERIMENT.customerTierABC.variations.variationB */ .Op.customerTierABC.variations.variationB) ? "Du hast keinen regelm\xe4\xdfigen Bedarf? Kein Problem!" : "",
        footNote: "qualification:rareCustomerTier.footNote"
    }
});
var budgetAndPeopleCountStep = (0,qualification_schema_questions_utils__WEBPACK_IMPORTED_MODULE_2__/* .createStep */ .yW)({
    id: STEP_IDS.budgetAndPeopleCount,
    questions: [
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.peopleCount */ .X.peopleCount,
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.pricePerPerson */ .X.pricePerPerson,
        qualification_schema_questions__WEBPACK_IMPORTED_MODULE_1__/* .questions.totalBudget */ .X.totalBudget, 
    ],
    content: {
        titleEn: "How many people are to be catered for and what is your budget?",
        titleDe: "Wie viele Personen sollen ca. verk\xf6stigt werden und was hast du f\xfcr ein Budget?"
    }
});
var steps = {
    city: cityStep,
    cateringCategories: cateringCategoryStep,
    eventDateAndLeadType: eventDateAndLeadTypeStep,
    dietaryRestriction: dietaryRestrictionStep,
    budgetAndPeopleCount: budgetAndPeopleCountStep,
    customerTier: customerTierStep,
    rareCustomerTierStep: rareCustomerTierStep
};
var _obj;
/**
 * A record of steps, where their id is the key
 */ var SCHEMA_STEPS = createStepSchema((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, STEP_IDS.cateringCategories, cateringCategoryStep), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, STEP_IDS.city, cityStep), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, STEP_IDS.eventDate, eventDateAndLeadTypeStep), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, STEP_IDS.dietaryRestrictions, dietaryRestrictionStep), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, STEP_IDS.budgetAndPeopleCount, budgetAndPeopleCountStep), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, STEP_IDS.customerTier, customerTierStep), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, STEP_IDS.rareCustomerTier, rareCustomerTierStep), _obj));
function createStepSchema(obj) {
    return obj;
}


/***/ }),

/***/ 47004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eb": function() { return /* binding */ localeToDateLocaleMapping; },
/* harmony export */   "nz": function() { return /* binding */ toUnixTimestamp; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* unused harmony export getDayNameFromDate */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46216);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83343);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70879);


var dateFormatByLocaleMapping = {
    en: "dd/MM/yyyy",
    de: "dd.MM.yy",
    da: "dd/MM/yyyy",
    "da-dk": "dd/MM/yyyy",
    "en-uk": "dd/MM/yyyy",
    "en-de": "dd/MM/yyyy",
    "de-at": "dd.MM.yy",
    "de-ch": "dd.MM.yy",
    "de-de": "dd.MM.yy"
};
var localeToDateLocaleMapping = {
    en: date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    de: date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    da: date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    "da-dk": date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    "en-uk": date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    "en-de": date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    "de-at": date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    "de-ch": date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    "de-de": date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
};
function formatDate(dateString, locale) {
    if (dateString === null || typeof dateString === "undefined") {
        return null;
    }
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Date(dateString), dateFormatByLocaleMapping[locale], {
        locale: localeToDateLocaleMapping[locale]
    });
}
function toUnixTimestamp(date) {
    return (date.getTime() / 1000).toFixed(0);
}
function getDayNameFromDate(date) {
    return date ? format(date, "EEEE").toLowerCase() : undefined;
}


/***/ }),

/***/ 53279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ attributeNameForLocale; },
/* harmony export */   "u": function() { return /* binding */ algoliaAttributeNameForLocale; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48403);
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_capitalize__WEBPACK_IMPORTED_MODULE_0__);


var localeConfig = {
    locales: [
        "en",
        "de"
    ],
    defaultLocale: "de"
};
var algoliaAttributeNameForLocale = function(locale) {
    return function(name) {
        var toLocalizedAlgoliaKey = function(name) {
            var parsedLocale = localeConfig.locales.includes(locale) ? locale : localeConfig.defaultLocale;
            return "".concat(name, "_").concat(parsedLocale);
        };
        if (name.includes(".")) {
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(name.split("."), 2), scope = ref[0], fieldName = ref[1];
            // @ts-expect-error: edge case, hard to type
            return "".concat(scope, ".").concat(toLocalizedAlgoliaKey(fieldName));
        }
        return toLocalizedAlgoliaKey(name);
    };
};
var attributeNameForLocale = function(locale) {
    return function(name) {
        if (!localeConfig.locales.includes(locale)) return "".concat(name).concat(lodash_capitalize__WEBPACK_IMPORTED_MODULE_0___default()(localeConfig.defaultLocale));
        return "".concat(name).concat(lodash_capitalize__WEBPACK_IMPORTED_MODULE_0___default()(locale));
    };
};


/***/ })

}]);